<section class="tabs">
    <ul>
        <li [ngClass]="{'active': tipoEstadisticas === 1}" (click)="showDesignacionesPais()">
            {{'centralEstadisticas.designaciones.tabs.nDesignacionesPais.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 2}" (click)="showDesignacionesDenominacion()">
            {{'centralEstadisticas.designaciones.tabs.nDesignacionesDenominacion.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 3}" (click)="showDesignacionesCampanya()">
            {{'centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 7}" (click)="showKilosCampanya()">
            {{'centralEstadisticas.designaciones.tabs.kilosCampanyas.titulo' | translate}}
        </li>
    </ul>
    <content>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 1">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesPais.paises' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica1">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasDesignaciones.grafica1.horizontal" 
                                            [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                            [categorias]="graficasDesignaciones.grafica1.paises" 
                                            [data]="graficasDesignaciones.grafica1.numDesignaciones"
                                            [valorMaximo]="graficasDesignaciones.grafica1.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesPais.descripcionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.nDesignacionesPais.paises', dataDesignaciones.designaciones_DesignacionesPais_Paises_1.lista, 'regularTab', 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica1">
                                <lib-simple-dougnhut-chart [labels]="graficasDesignaciones.grafica1.paises" 
                                [series]="graficasDesignaciones.grafica1.numDesignaciones" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                [colors]="graficasDesignaciones.grafica1.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
				<div class= "section" style="justify-content: center;">
					<div>
						<h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesPais.paisDenominaciones' | translate}}</h3>
					</div>
				</div> 
                <div class="section">
                    <div *ngIf="graficasDesignaciones && graficasDesignaciones.grafica2.designaciones"
                        [ngClass]="{'controlDisplay': !graficasDesignaciones.grafica2.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica2.bigWidthEtq" [stackType]="'normal'"
                                    [info]="graficasDesignaciones.grafica2.designaciones" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                    [categorias]="graficasDesignaciones.grafica2.categorias"
                                    [valorMaximo]="graficasDesignaciones.grafica2.valorMaximo"
                                    [showDatalabels]="true"
                                    [colors]="graficasDesignaciones.grafica2.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesPais.descripcionPaisDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.nDesignacionesPais.paisDenominaciones', dataDesignaciones.designaciones_DesignacionesPais_PaisDenominaciones_Grid_2, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica2.porcentajes">
                                    <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica2.bigWidthPes" [stackType]="'100%'"
                                        [info]="graficasDesignaciones.grafica2.porcentajes" [nombre]="'%'" 
                                        [categorias]="graficasDesignaciones.grafica2.categorias"
                                        [showDatalabels]="true"
                                        [colors]="graficasDesignaciones.grafica2.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 2">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesDenominacion.denominaciones' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica3">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasDesignaciones.grafica3.horizontal" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)"
                                    [categorias]="graficasDesignaciones.grafica3.denominaciones"
                                    [data]="graficasDesignaciones.grafica3.numDesignaciones"
                                    [valorMaximo]="graficasDesignaciones.grafica3.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesDenominacion.descripcionDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.nDesignacionesDenominacion.denominaciones', dataDesignaciones.designaciones_DesignacionesDenominacion_Denominaciones_1.lista, 'regularTab', 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica3">
                                <lib-simple-dougnhut-chart [labels]="graficasDesignaciones.grafica3.denominaciones"
                                    [series]="graficasDesignaciones.grafica3.numDesignaciones" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                    [colors]="graficasDesignaciones.grafica3.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
				<div class= "section" style="justify-content: center;">
					<div>
                        <h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesDenominacion.denominacionPaises' | translate}}</h3>
					</div>
				</div>  
                <div class="section">
                    <div *ngIf="graficasDesignaciones && graficasDesignaciones.grafica4.designaciones"
                        [ngClass]="{'controlDisplay': !graficasDesignaciones.grafica4.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica4.bigWidthEtq" [stackType]="'normal'"
                                    [info]="graficasDesignaciones.grafica4.designaciones"
                                    [categorias]="graficasDesignaciones.grafica4.categorias"
                                    [valorMaximo]="graficasDesignaciones.grafica4.valorMaximo"
                                    [showDatalabels]="true" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                    [colors]="graficasDesignaciones.grafica4.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesDenominacion.descripcionDenominacionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.nDesignacionesDenominacion.denominacionPaises', dataDesignaciones.designaciones_DesignacionesDenominacion_DenominacionPaises_Grid_2, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica4.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica4.bigWidthPes" [stackType]="'100%'"
                                    [info]="graficasDesignaciones.grafica4.porcentajes" [nombre]="'%'" 
                                    [categorias]="graficasDesignaciones.grafica4.categorias"
                                    [showDatalabels]="true"
                                    [colors]="graficasDesignaciones.grafica4.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 3">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.campanyas' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica5">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasDesignaciones.grafica5.horizontal" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)"
                                    [categorias]="graficasDesignaciones.grafica5.anyos"
                                    [data]="graficasDesignaciones.grafica5.numDesignaciones"
                                    [valorMaximo]="graficasDesignaciones.grafica5.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.descripcionCampanyas' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.campanyas', dataDesignaciones.designaciones_DesignacionesCampanya_Campanyas_1.lista, 'regularTab', 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica5">
                                <lib-simple-dougnhut-chart [labels]="graficasDesignaciones.grafica5.anyos"
                                    [series]="graficasDesignaciones.grafica5.numDesignaciones" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                    [colors]="graficasDesignaciones.grafica5.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
				<div class= "section" style="justify-content: center;">
					<div>
                        <h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.paisesCampanya' | translate}}</h3>
					</div>
				</div>  
                <div class="section">
                    <div *ngIf="graficasDesignaciones && graficasDesignaciones.grafica6.designaciones"
                        [ngClass]="{'controlDisplay': !graficasDesignaciones.grafica6.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica6.bigWidthEtq" [stackType]="'normal'"
                                    [info]="graficasDesignaciones.grafica6.designaciones"
                                    [categorias]="graficasDesignaciones.grafica6.categorias"
                                    [valorMaximo]="graficasDesignaciones.grafica6.valorMaximo"
                                    [showDatalabels]="true" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                    [colors]="graficasDesignaciones.grafica6.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.descripcionPaisesCampanyas' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.paisesCampanya', dataDesignaciones.designaciones_DesignacionesCampanya_PaisesCampanya_Grid_2, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica6.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica6.bigWidthPes" [stackType]="'100%'"
                                    [info]="graficasDesignaciones.grafica6.porcentajes"
                                    [categorias]="graficasDesignaciones.grafica6.categorias"
                                    [showDatalabels]="true" [nombre]="'%'" 
                                    [colors]="graficasDesignaciones.grafica6.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
				<div class= "section" style="justify-content: center;">
					<div>
						<h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.denominacionesCampanya' | translate}}</h3>
					</div>
				</div> 
                <div class="section">
                    <div *ngIf="graficasDesignaciones && graficasDesignaciones.grafica7.designaciones"
                        [ngClass]="{'controlDisplay': !graficasDesignaciones.grafica7.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica7.bigWidthEtq" [stackType]="'normal'"
                                    [info]="graficasDesignaciones.grafica7.designaciones"
                                    [categorias]="graficasDesignaciones.grafica7.categorias"
                                    [valorMaximo]="graficasDesignaciones.grafica7.valorMaximo"
                                    [showDatalabels]="true" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" 
                                    [colors]="graficasDesignaciones.grafica7.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.descripcionDenominacionesCampanya' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.nDesignacionesCampanyas.denominacionesCampanya', dataDesignaciones.designaciones_DesignacionesCampanya_DenominacionesCampanya_Grid_3, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica" *ngIf="graficasDesignaciones && graficasDesignaciones.grafica7.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasDesignaciones.grafica7.bigWidthPes" [stackType]="'100%'"
                                    [info]="graficasDesignaciones.grafica7.porcentajes"
                                    [categorias]="graficasDesignaciones.grafica7.categorias"
                                    [showDatalabels]="true" [nombre]="'%'" 
                                    [colors]="graficasDesignaciones.grafica7.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 7">
            <div style="flex-direction: column;">
                <div class= "section" style="justify-content: center;">
                    <div>
                        <h3>{{'centralEstadisticas.designaciones.tabs.kilosCampanyas.paises' | translate}}</h3>
                    </div>
                </div> 
                <div class="section">
                    <div *ngIf="graficasDesignaciones && graficasDesignaciones.graficas8">
                        <div class="container" *ngFor="let grafica of graficasDesignaciones.graficas8[0]">
                            <div class="grafica">
                                <lib-spline-area-chart [type]="'area'" [title]="'(' + ('centralEstadisticas.denominacion' | translate) + grafica.denominacion + ')'" [nombre]="'Kg'"
                                            [categorias]="grafica.categorias" [data]="grafica.designaciones" [colors]="grafica.colores"></lib-spline-area-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.kilosCampanyas.preDescripcionPaises' | translate) + grafica.denominacion + ('centralEstadisticas.designaciones.tabs.kilosCampanyas.postDescripcionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.designaciones.tabs.kilosCampanyas.paises', dataDesignaciones.designaciones_KilosCampanyas_Paises_Grid_1, 'kgCampanyasPaises', '', grafica.denominacion)"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section" style="justify-content: center;">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.kilosCampanyas.denominaciones' | translate}}</h3>
                        </div>
                    </div>     
                <div *ngIf="graficasDesignaciones && graficasDesignaciones.graficas8">
                    <div class="container" *ngFor="let grafica of graficasDesignaciones.graficas8[1]">
                        <div class="grafica">
                            <lib-spline-area-chart [type]="'area'" [title]="'(' + ('centralEstadisticas.pais' | translate) + grafica.pais + ')'" [nombre]="'Kg'"
                                           [categorias]="grafica.categorias" [data]="grafica.designaciones" [colors]="grafica.colores"></lib-spline-area-chart>
                            <div class="buttons-section">
                                <button [tooltip]="('centralEstadisticas.designaciones.tabs.kilosCampanyas.preDescripcionDenominaciones' | translate) + grafica.pais"><i class="fa-solid fa-info"></i></button>
                                <button 
                                    class="grid" 
                                    [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                    (click)="showGrid('centralEstadisticas.designaciones.tabs.kilosCampanyas.denominaciones', dataDesignaciones.designaciones_KilosCampanyas_Denominaciones_Grid_2, 'kgCampanyasDenominaciones', '', grafica.pais)"><i class="fas fa-table"></i></button>
                                <!-- <button><i class="fas fa-file-pdf"></i></button>
                                <button><i class="fas fa-file-excel"></i></button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    </content>
</section>
<div class="modal" *ngIf="gridModal">
    <div class="modal-content">
        <header>
            <h4>{{gridTitle | translate}}</h4>
            <i class="fas fa-times" (click)="gridModal = !gridModal"></i>
          </header>
        <app-grid-estadisticas-designacion-pd class="component" [dataGrid]="parentDataGrid" [currentTab]="parentCurrentTab" (hideTable)="hideModal()"></app-grid-estadisticas-designacion-pd>
    </div>
</div>